// Policy Codes
export default {
  ADDITIONAL_DRIVERS: 'ADDR',
  CREDIT_CARD_GUARANTEE: 'CCG',
  WAYFINDING_POLICY: 'WAY',
};
